import React from "react";
import { withRouter } from "react-router";

import { withItemsIntellegence } from "../../../shared/containers/containerItemsIntellegence";
import { withTimerangeIntelligence } from "../../../shared/containers/containerTimerangeIntelligence";
import { withIntelligenceDateControls } from "./../../../shared/containers/containerIntelligenceDateControls";

import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import { states } from "../../../reducers/queriesStates";
import { withVideoTools } from "../../../shared/containers/containerVideoTools";

const getIntellegenceData = (props) => {
  const {
    match,
    rangeStartDate,
    rangeEndDate,
    rangeStartTime,
    rangeEndTime,
    timerangeIntelligenceState,
    onGetTimerangeIntelligence,
    onResetTimeRangeIntelligence,
    onCloseIntelligenceDateControls,
    onSetVideoInterval,
  } = props;
  const carId = match.params.id;

  const startDate = new Date(rangeStartDate);
  const startTime = new Date(rangeStartTime);
  startDate.setHours(startTime.getHours());
  startDate.setMinutes(startTime.getMinutes());

  const endDate = new Date(rangeEndDate);
  const endTime = new Date(rangeEndTime);
  endDate.setHours(endTime.getHours());
  endDate.setMinutes(endTime.getMinutes());
  endDate.setSeconds(59);

  if (timerangeIntelligenceState !== states.NOT_REQUESTED) {
    onResetTimeRangeIntelligence();
  }

  onGetTimerangeIntelligence({
    carId,
    startDate,
    endDate,
  });

  onSetVideoInterval(startDate, endDate);
  // onCloseIntelligenceDateControls();
};

const IntelligenceInTimeRangeButtonWrapper = (props) => {
  const { disabled, timerangeIntelligenceState } = props;

  return (
    <ButtonPrimary
      handleClick={getIntellegenceData.bind(this, props)}
      title="Показать"
      disabled={disabled || timerangeIntelligenceState === states.REQUEST ? true : false}
    />
  );
};

export default withVideoTools(
  withTimerangeIntelligence(
    withIntelligenceDateControls(withItemsIntellegence(withRouter(React.memo(IntelligenceInTimeRangeButtonWrapper))))
  )
);
